import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=3df3a4c0&scoped=true"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
import style0 from "./Currency.vue?vue&type=style&index=0&id=3df3a4c0&prod&lang=scss"
import style1 from "./Currency.vue?vue&type=style&index=1&id=3df3a4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3a4c0",
  null
  
)

export default component.exports